import { FullStory, init, isInitialized } from '@fullstory/browser';
import { isFramed } from '../embedded/embeddedService';

// Session replay. Records standalone (top-level) sessions as their own, and in the
// embedded (cross-origin iframe) flow `recordCrossDomainIFrames` stitches the frame
// into the stigg-web session, which sets the same flag under the same org. In the
// frame, recording only happens while the parent is recording, so stigg-web's gating
// (production only, no internal users) carries over there.
//
// Not gated on isEmbedded(): the magic-link entry URL (/login?token=...) doesn't carry
// `embeddedPage=true` yet at bootstrap. An empty org id disables recording.

export const initFullstory = (): void => {
	const orgId = window._env_?.FULLSTORY_ORG_ID;
	if (!orgId) {
		return;
	}
	init({ orgId, recordCrossDomainIFrames: true });
};

// Call when auth is cleared (logout, 401/403) so one replay never spans two users in
// the same tab. Skipped in the frame: there the session belongs to the parent.
export const endFullstorySession = (): void => {
	if (!isInitialized() || isFramed()) {
		return;
	}
	FullStory('setIdentity', { anonymous: true });
};
